/*
 * @Author: your name
 * @Date: 2020-03-02 19:35:28
 * @LastEditTime: 2020-03-08 02:23:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \kkcloud-kk-agentapp-download\src\config\base.ts
 */
/*
ios超级签
*/
export var siteUrl = [
    {
        siteId: 1,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=C6eBySIGLX',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=C6eBySIGLX'
        }
    },
    {
        siteId: 2,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=zE4aPwwmGH',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=r9NwKUj6SC'
        }
    },
    {
        siteId: 3,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=5fc1XLJYkd',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=YlFrnLpcsU'
        }
    },
    {
        siteId: 4,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=WCv9VuXIe1',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=AcmQUbS2Dm'
        }
    },
    {
        siteId: 5,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=QDX7jmHRwI',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=LH7CTf3zJG'
        }
    },
    {
        siteId: 6,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=0DnAf2CT8d',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=UYq0efnfml'
        }
    },
    {
        siteId: 7,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=WEgngZN7aF',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=Huv3wm5NyW'
        }
    },
    {
        siteId: 8,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=MOPtxUFzcj',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=OR2VG1Qemf'
        }
    },
    {
        siteId: 10,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=jwWFLNMaI6',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=P9RQLpeNna'
        }
    },
    {
        siteId: 11,
        url: {
            test: 'https://ht-ss.dw64.app/download?step=0&appKey=ht33ZAzn7O',
            pro: 'https://ht-ss.dw64.app/download?step=0&appKey=WpwMMGyTrB'
        }
    }
];
export var enterpriseSignUrl = {
    1001: 'itms-services://?action=download-manifest&url=https://agent.buweisheji.com/down/ios/mainfest.plist',
    2001: 'itms-services://?action=download-manifest&url=https://agent.zghn920dh.com/down/ios/mainfest.plist',
    3001: 'itms-services://?action=download-manifest&url=https://agent.huaerzf.com/down/ios/mainfest.plist',
    4001: 'itms-services://?action=download-manifest&url=https://agent.zgwjsj.com/down/ios/mainfest.plist',
};
